import { getAuth } from "firebase/auth";
import { useContext } from "react";
import {
  ExtendedFirebaseUser,
  SellarSessionContext,
} from "../contexts/SellarSessionContext";
import { firebaseApp } from "../firebaseApp";

export type { ExtendedFirebaseUser };

export const auth = getAuth(firebaseApp);

export const useFirebaseUser = () => {
  const context = useContext(SellarSessionContext);
  if (context === undefined) {
    throw new Error("useFirebaseUser must be within SellarSessionProvider");
  }
  return context.firebase;
};
